var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'homonym'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm.currentRound.steps ? _c('div', {
    staticClass: "steps-container",
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "transition": "fade"
    }
  }, [_c('div', {
    staticClass: "step",
    attrs: {
      "transition": "fade"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Left image",
      "src": _vm.images.left
    }
  }), _c('text-display-list', {
    attrs: {
      "text-size": "small"
    }
  }, [_c('li', {
    attrs: {
      "transition": "fade"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.stepLeft.answer,
      "text-step": 0,
      "shouldBeCurrentStep": _vm.progress.stepIndex === 0 && _vm.textToType === 'answer',
      "shouldBeCompletedStep": _vm.progress.stepIndex > 0 || _vm.textToType === 'description'
    }
  })], 1), _c('li', {
    attrs: {
      "transition": "fade"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.stepLeft.description,
      "text-step": 0,
      "shouldBeCurrentStep": _vm.progress.stepIndex === 0 && _vm.textToType === 'description',
      "shouldBeCompletedStep": _vm.progress.stepIndex > 0
    }
  })], 1)])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showRight,
      expression: "showRight"
    }],
    staticClass: "step",
    attrs: {
      "transition": "fade"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Right image",
      "src": _vm.images.right
    }
  }), _c('text-display-list', {
    attrs: {
      "text-size": "small"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.progress.stepIndex >= 1,
      expression: "progress.stepIndex >= 1"
    }],
    attrs: {
      "transition": "fade"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.stepRight.answer,
      "text-step": 1,
      "shouldBeCurrentStep": _vm.progress.stepIndex === 1 && _vm.textToType === 'answer',
      "shouldBeCompletedStep": _vm.textToType === 'description'
    }
  }, [_vm._v("\n                >\n              ")])], 1), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.progress.stepIndex >= 1,
      expression: "progress.stepIndex >= 1"
    }],
    attrs: {
      "transition": "fade"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.stepRight.description,
      "text-step": 1,
      "shouldBeCurrentStep": _vm.progress.stepIndex === 1 && _vm.textToType === 'description'
    }
  })], 1)])], 1)]) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }